<section class="w-full h-screen flex flex-col">
  <df-iframe
    [funnelId]="funnelId"
    inputType="landing page"
    class="w-full h-full"
  ></df-iframe>
</section>
